import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dictaVueComponents from 'dicta-vue-components'
import VueHead from 'vue-head'
import VueCookies from 'vue-cookies'
import VueHotkey from 'v-hotkey'
import VueMq from 'vue-mq'

Vue.config.productionTip = false
Vue.use(VueHotkey)
Vue.use(dictaVueComponents, {hebrew: true, useBodyClass: true})
Vue.use(VueHead)
Vue.use(VueCookies)

Vue.use(VueMq, {
  breakpoints: {
    xs: 991,
    sm: 992,
    md: 1250,
    lg: Infinity,
  },
  defaultBreakpoint: 'xs' // customize this for SSR
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
